/**
 * This function creates an array from the min to max, plus a final number
 * that is one more than the max (ie 9+ if the max is 8). Selecting that will
 * prompt the customer to call the restaurant instead.
 */
export const getNumberOfGuestsOptions = (min: number, max: number) => {
  const arraySize = max - min + 2;
  return Array.from(Array(arraySize).keys()).map(num => num + min);
};
